import axios from "axios";
import { API_CONFIG } from "../config/api";
import { useFamilyAuth } from "../store/familyAuthStore";

const apiClient = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
});

apiClient.interceptors.request.use((config) => {
  const token = useFamilyAuth.getState().token;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

apiClient.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 || err?.response?.status === 403) {
      useFamilyAuth.getState().logout();
    }
    return Promise.reject(err);
  }
);

export default apiClient;
